import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import MembershipSuccess from "@/pages/MembershipSuccess";
import MembershipCancel from "@/pages/MembershipCancel";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain bg-paper text-ink">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/membership/success" element={<MembershipSuccess />} />
          <Route path="/membership/cancel" element={<MembershipCancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
